module.exports = __webpack_public_path__ + "img/room-1.254017d2.jpg";